import React from "react";
import { Box, Button, Textarea } from "@chakra-ui/react";

export default function QuoteFooter({
  note,
  onNoteChange,
  isSaving,
  onSave,
}) {
  return (
    <Box mt={4} width="80%">
      <Textarea
        mb={3}
        placeholder="Note…"
        value={note}
        onChange={(e) => onNoteChange(e.target.value)}
      />

      <Button
        bg="teal.500"
        color="white"
        onClick={onSave}
        isLoading={isSaving}
        _hover={{ boxShadow: "lg" }}
      >
        Crea Preventivo
      </Button>
    </Box>
  );
}
